/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SecondDegreeGuard } from 'src/guards/second-degree.guard';
import { AccountingProceduresComponent } from './accounting-procedures/accounting-procedures.component';
import { DutyProceedingsInitiationComponent } from './cases/duty-proceedings-initiation/duty-proceedings-initiation.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { EntranceComponent } from './entrance/entrance.component';
import { CaseSearchByClassificationComponent } from './global-admin/case-search-by-classification/case-search-by-classification.component';
import { HomepageComponent } from './homepage/homepage.component';
import { LegalSubjectDetailsComponent } from './legal-subjects/legal-subject-details/legal-subject-details.component';
import { LegalSubjectsComponent } from './legal-subjects/legal-subjects.component';
import { NewLegalSubjectComponent } from './legal-subjects/new-legal-subject/new-legal-subject.component';
import { NotificationContentComponent } from './notification-content/notification-content.component';
import { NspRequestComponent } from './nsp-request/nsp-request.component';
import { ProfileComponent } from './profile/profile.component';
import { ScheduleCasesComponent } from './schedule-cases/schedule-cases.component';
import { CpsuSubjectDetailsComponent } from './subjects/cpsu-subject-details/cpsu-subject-details.component';
import { NewSubjectComponent } from './subjects/new-subject/new-subject.component';
import { ServiceProviderSubjectDetailsComponent } from './subjects/service-provider-subject-details/service-provider-subject-details.component';
import { SubjectCaseComponent } from './subjects/subject-details/subject-case/subject-case.component';
import { SubjectDetailsComponent } from './subjects/subject-details/subject-details.component';
import { SubjectsComponent } from './subjects/subjects.component';

const appRoutes: Routes = [
   { path: '', component: HomepageComponent },
   { path: 'entrancePapers', component: EntranceComponent },
   { path: 'legal_subjects', component: LegalSubjectsComponent },
   { path: 'legal_subjects/:id', component: LegalSubjectDetailsComponent },
   { path: 'new_legal_subject', component: NewLegalSubjectComponent },
   { path: 'new_legal_subject/:id', component: NewLegalSubjectComponent },
   { path: 'new-subject', component: NewSubjectComponent },
   { path: 'new-subject/:id', component: NewSubjectComponent },
   { path: 'profile', component: ProfileComponent },
   { path: 'schedule-cases', component: ScheduleCasesComponent },
   { path: 'notifications', component: NotificationContentComponent },
   { path: 'cases/details/:id/:subjectId/:csrId', component: SubjectCaseComponent },
   {
      path: 'cases',
      loadChildren: () => import('./cases/cases.module').then(m => m.CasesModule),
   },

   {
      path: 'subjects',
      children: [
         { path: ':id', component: SubjectDetailsComponent },
         { path: 'cpsu/:id', component: CpsuSubjectDetailsComponent },
         { path: 'service-providers/:id', component: ServiceProviderSubjectDetailsComponent },
         { path: '', component: SubjectsComponent, pathMatch: 'full' },
      ],
   },
   {
      path: 'submissions',
      children: [{ path: 'entrancePaper/:id', component: EntranceComponent }],
   },
   {
      path: 'supervision',
      loadChildren: () => import('./supervision/supervision.module').then(m => m.SupervisionModule),
   },
   { path: 'nspRequest', component: NspRequestComponent },
   { path: 'duty-proceedings-initiation', component: DutyProceedingsInitiationComponent },
   {
      path: 'collections',
      loadChildren: () => import('./collections/collections.module').then(m => m.CollectionsModule),
   },
   {
      path: 'statistics',
      loadChildren: () => import('./statistics/statistics.module').then(m => m.StatisticsModule),
   },
   { path: 'accounting-procedures', component: AccountingProceduresComponent },
   { path: 'cases-by-classification', component: CaseSearchByClassificationComponent, canActivate: [SecondDegreeGuard] },

   {
      path: 'admin',
      loadChildren: () => import('./global-admin/global-admin.module').then(m => m.GlobalAdminModule),
   },
   {
      path: 'accounting',
      loadChildren: () => import('./features/accounting/accounting.module').then(m => m.AccountingModule),
   },
   { path: '**', component: PageNotFoundComponent }, // mora da bude poslednji u nizu ruta
];

@NgModule({
   imports: [RouterModule.forRoot(appRoutes)],
   exports: [RouterModule],
})
export class AppRoutingModule {}
